import Vue from 'vue'
import Cognito from './cognito'
import configure from './../config'

Vue.use(Cognito, configure.AWSConfig)

export default new Cognito()